module.exports = __webpack_public_path__ + "static/media/2020-12-12-01.db22d3b3.jpg";